import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { colors } from '../../../constants'

const PaddingMessage = styled.div`
    background: ${colors.blue}D0;
    border-radius: 5px;
    box-shadow: 1px 1px 4px 0 #0004;
    color: ${colors.bluelightest};
    cursor: pointer;
    font-size: 26px;
    padding: 50px 50px 30px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    user-select: none;
    width: 400px;
    z-index: 2000;
`

const Dismiss = styled.div`
    color: ${colors.bluelighter};
    position: absolute;
    top: 0;
    right: 15px;
`

const CounterWrapper = styled.div`
    margin: 10px auto 0;
    overflow: hidden;
    text-align: center;
    width: 15px;
    height: 40px;
`

const Counter = styled.div`
    position: absolute;

    ${({ counter }) =>
        counter &&
        `
      animation: counter-${counter} 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
      @keyframes counter-${counter} {
        0% {
          opacity: 0;
          transform: scale(0);
        }
        25% {
          opacity: 1;
        }
        75% {
          opacity: 1;
        }
        100% {
          opacity: 0;
          transform: scale(1.5);
        }
    `}
`

const FLASH_MESSAGE_TTL = 3

class FlashMessage extends PureComponent {
    static propTypes = {
        id: PropTypes.string.isRequired,
        children: PropTypes.node.isRequired,
        onDismissFlash: PropTypes.func,
    }

    static defaultProps = {
        onDismissFlash: () => null,
    }

    constructor(props) {
        super(props)

        this.state = {
            counter: 0,
        }

        this.dismissMessage = this.dismissMessage.bind(this)
        this.onMessageClick = this.onMessageClick.bind(this)
        this.initCountdown = this.initCountdown.bind(this)
        this.initDimissTimeout = this.initDimissTimeout.bind(this)
        this.stopCountdown = this.stopCountdown.bind(this)
        this.stopDismissTimeout = this.stopDismissTimeout.bind(this)
    }

    componentDidMount() {
        this.initDimissTimeout()
        this.initCountdown()
    }

    componentDidUpdate(lastProps) {
        const { children: lastChildren } = lastProps
        const { children: nextChildren } = this.props

        if (lastChildren !== nextChildren) {
            this.stopCountdown()
            this.stopDismissTimeout()
            this.initDimissTimeout()
            this.initCountdown()
        }
    }

    componentWillUnmount() {
        this.stopDismissTimeout()
        this.stopCountdown()
    }

    onMessageClick() {
        this.dismissMessage()
    }

    dismissMessage() {
        const { onDismissFlash, id } = this.props
        onDismissFlash(id)
        this.stopCountdown()
        this.stopDismissTimeout()
    }

    initCountdown() {
        const fn = () => {
            const countOneLess = function () {
                const { counter } = this.state
                const nextCount = counter - 1

                if (nextCount < 0) {
                    this.stopCountdown()
                }

                this.setState({ counter: nextCount })
            }

            this.countdown = setInterval(countOneLess.bind(this), 1000)
        }

        this.setState({ counter: FLASH_MESSAGE_TTL }, fn.bind(this))
    }

    stopCountdown() {
        if (this.countdown) {
            clearInterval(this.countdown)
        }
    }

    initDimissTimeout() {
        this.timeout = setTimeout(this.dismissMessage, FLASH_MESSAGE_TTL * 1000)
    }

    stopDismissTimeout() {
        if (this.timeout) {
            clearTimeout(this.timeout)
        }
    }

    renderCounter() {
        const { counter } = this.state
        return <Counter counter={counter}>{counter}</Counter>
    }

    render() {
        const { children } = this.props
        return (
            <PaddingMessage onClick={this.onMessageClick}>
                <Dismiss>&times;</Dismiss>
                {children}
                <CounterWrapper>{this.renderCounter()}</CounterWrapper>
            </PaddingMessage>
        )
    }
}

export default FlashMessage
